/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const n = {
  hide: "hide",
  hideChildren: "hide-children"
};
function i(n) {
  if (n) return null != n.listMode ? n.listMode : void 0;
}
function e(n) {
  return null != n && "minScale" in n && null != n.minScale ? n.minScale : void 0;
}
function l(n) {
  return null != n && "maxScale" in n && null != n.maxScale ? n.maxScale : void 0;
}
function r(n) {
  if (!n) return "inherited";
  const i = b(p(n) ? n.layer : n);
  return null != i ? i ? "independent" : "inherited" : "visibilityMode" in n && null != n.visibilityMode ? n.visibilityMode : "independent";
}
function t(i) {
  if (i && (!("type" in i) || "wmts" !== i.type) && i.listMode !== n.hideChildren) return "sublayers" in i ? "sublayers" : "layers" in i ? "layers" : void 0;
}
function u(n) {
  const i = (n?.layer && p(n.layer) ? n.layer.layer : void 0) ?? n?.layer;
  return !!i && (m(i) ?? !0);
}
function a(e) {
  return i(e) !== n.hide;
}
function s(n, i) {
  if (!n || null == i || isNaN(i)) return !1;
  const r = e(n),
    t = l(n),
    u = null != r && !isNaN(r) && r > 0 && i > r,
    a = null != t && !isNaN(t) && t > 0 && i < t;
  return u || a;
}
function o(n, i) {
  n?.sort((n, e) => {
    const l = "uid" in n ? i.indexOf(n.uid) : -1,
      r = "uid" in e ? i.indexOf(e.uid) : -1;
    return l > r ? -1 : l < r ? 1 : 0;
  });
}
function c(n, i) {
  const e = n?.layer;
  if (!e) return;
  const l = t(e);
  if (!l) return;
  let r;
  "layers" === l && "layers" in e ? r = e.layers : "sublayers" === l && "sublayers" in e && (r = e.sublayers), o(r, i);
}
function y(n) {
  const i = n?.layer;
  return i && "layers" in i ? i.layers : null;
}
function d(n, i) {
  const e = n.layer?.uid;
  return null != e ? i.find(n => n.layer?.uid === e) : null;
}
function f(n) {
  const i = p(n) ? n : null,
    e = n?.parent,
    l = null != e && "type" in e && "map-image" === e.type ? i?.source : null,
    r = "";
  return l && e ? {
    layer: e,
    title: r,
    sublayerIds: [l.mapLayerId]
  } : {
    layer: n,
    title: r
  };
}
function p(n) {
  return null != n && "layer" in n && null != n.layer;
}
function b(n) {
  const i = h(n);
  return null != i && "supportsSublayerVisibility" in i ? i.supportsSublayerVisibility : void 0;
}
function m(n) {
  const i = h(n);
  return null != i && "supportsDynamicLayers" in i ? i.supportsDynamicLayers : void 0;
}
function h(n) {
  return n && "capabilities" in n && null != n.capabilities && "exportMap" in n.capabilities ? n.capabilities.exportMap : void 0;
}
export { a as canDisplayLayer, u as canSortSublayers, i as findLayerListMode, l as findLayerMaxScale, e as findLayerMinScale, r as findLayerVisibilityMode, d as findSelectedItem, y as getItemLayers, f as getLegendLayerInfo, t as getNormalizedChildLayerProperty, s as isLayerOutsideScaleRange, p as isSublayer, c as sortChildLayersToIds, o as sortLayersToIds };